<div class="container-fluid mt-3 department-page">
  <!-- Page header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h3 class="dept-title mb-1">Departments</h3>
      <small class="text-muted">
        Showing {{ filteredDepartments.length }} of {{ departments.length }} departments
      </small>
    </div>

    <div>
      <!-- <button class="btn refresh-btn" (click)="reload()">
        <i class="fas fa-sync-alt"></i> Refresh                   - Refresh Button
      </button> -->
      <!-- If you have Add Dept page in future, hook it here -->
      <!--
      <button class="btn btn-sm btn-primary ms-2" (click)="addDepartment()">
        <i class="fas fa-plus"></i> Add Department
      </button>
      -->
    </div>
  </div>

  <!-- Filters card -->
  <div class="card dept-filter-card mb-3">
    <div class="card-body py-2">
      <div class="row align-items-center g-2">
        <!-- Search -->
        <div class="col-md-6">
          <div class="input-group dept-search-box">
            <span class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Search by department name, foreman or warehouse"
              [(ngModel)]="searchText"
              (ngModelChange)="applyFilters()"
            />
          </div>
        </div>

        <!-- Summary -->
        <div class="col-md-6 text-md-end mt-2 mt-md-0">
          <span class="badge badge-light text-muted dept-summary-pill">
            <i class="fas fa-building me-1"></i>
            {{ filteredDepartments.length }} visible
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main card -->
  <div class="card dept-card">
    <!-- Loading overlay -->
    <div *ngIf="isLoading" class="dept-loading-overlay">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-2 text-muted small">Loading departments...</div>
      </div>
    </div>

    <div class="card-body p-0">
      <!-- Error -->
      <div *ngIf="!isLoading && loadError" class="alert alert-danger m-3">
        {{ loadError }}
      </div>

      <!-- No data -->
      <div
        *ngIf="!isLoading && !loadError && filteredDepartments.length === 0"
        class="alert alert-info m-3"
      >
        No departments found. Try changing the filters.
      </div>

      <!-- Table -->
      <div
        class="table-responsive"
        *ngIf="!isLoading && !loadError && filteredDepartments.length > 0"
      >
        <table class="table table-hover mb-0 dept-table">
          <thead class="thead-light">
            <tr>
              <th style="width: 35%;">Department Name</th>
              <th style="width: 25%;">Foreman Name</th>
              <th style="width: 20%;">Warehouse Name</th>
              <th style="width: 10%;" class="text-end">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let dept of filteredDepartments; trackBy: trackByDept"
              (click)="onRowClick(dept)"
              class="dept-row"
            >
              <!-- Department name -->
              <td class="align-middle">
                <div class="fw-bold dept-name">
                  <i class="fas fa-sitemap text-muted me-1"></i>
                  {{ dept.department_name || '-' }}
                </div>
              </td>

              <!-- Foreman -->
              <td class="align-middle">
                <div>
                  <i class="fas fa-user text-muted me-1"></i>
                  {{ dept.department_Foreman_name || 'Not assigned' }}
                </div>
              </td>

              <!-- Warehouse -->
              <td class="align-middle">
                <div>
                  <i class="fas fa-warehouse text-muted me-1"></i>
                  {{ dept.warehouse_name || '-' }}
                </div>
              </td>

              <!-- Actions -->
              <td class="align-middle text-end">
                <button
                  class="btn btn-edit"
                  (click)="editDepartment(dept.department_id); $event.stopPropagation()"
                >
                  <i class="fas fa-edit"></i> Edit
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
